module.exports = __webpack_public_path__ + "img/manage_chats.a623635a.svg";